'use client'
import { ApolloClient, InMemoryCache } from '@apollo/client'
const cache: InMemoryCache = new InMemoryCache()

const apiKey = process.env.NEXT_PUBLIC_THE_GRAPH_API_KEY as string
export const client = new ApolloClient({
  uri: 'https://gateway.thegraph.com/api/subgraphs/id/EibndopsSH6nDurvWPMfhiSPvxvFzegyGHm7xR7zhExb',
  headers: { Authorization: `Bearer ${apiKey}` },
  cache
})

export const blockClient = new ApolloClient({
  uri: 'https://gateway.thegraph.com/api/subgraphs/id/24iCSZzykPgVeCJeLDHPbqYXPtvHNgpEd5D2UD3gND9u',
  headers: { Authorization: `Bearer ${apiKey}` },
  cache
})
